import Head from "next/head";
import { useRouter } from "next/router";
import { useEffect } from "react";
import Layout from "../components/Layout";
import Loader from "../components/Loader";
import TransactionHistory from "../components/TransactionHistory";
import CallCenter from "../containers/HelpCenter/components/CallCenter";
import { Routes } from "../routes/RouteConstants";
import { CREDITS_ON_HOLD } from "../services/constants";
import { isMobileDevice } from "../services/utils";
import TransactionHistoryStore from "../zustandStores/TransactionHistoryStore";
import classes from "./css/transaction-history.module.css";
import useCreditProfileStore from "../zustandStores/userCreditProfileStore";
import { JhText } from "designPackages/textPackage";
import ActionButton from "../components/TransactionHistory/ActionButton";
import LogService from "services/LogService";
import CREDIT_EVENTS from "utils/CreditEvents";
import { HELP_CONTACT } from "services/HelpCenterService/HelpCenterConstant";

export default function TransactionHistoryPage(props) {
  const { fetchHistory, fetchedState, data } = TransactionHistoryStore(
    state => ({
      fetchHistory: state.fetchHistory,
      fetchedState: state.fetchedState,
      data: state.data
    })
  );
  const { creditFetchedState, fetchCreditData } = useCreditProfileStore(
    state => ({
      creditFetchedState: state.fetchedState,
      fetchCreditData: state.fetchData
    })
  );

  const router = useRouter();
  const { query, pathname } = router;
  const { tabId } = query;
  const isReservedTab = tabId === CREDITS_ON_HOLD;

  useEffect(() => {
    if (query) {
      fetchHistory(query);
    }
  }, [query]);

  const goToBack = {
    url: isReservedTab ? Routes.TRANSACTION_HISTORY : Routes.DASHBOARD,
    title: isReservedTab ? "Back to Transaction History" : "Go to Home"
  };

  function onRefresh() {
    const queryParams = {};
    if (query.recruiterId) {
      queryParams.recruiterId = query.recruiterId;
    }
    LogService.log(CREDIT_EVENTS.TH_REFRESH_CLICKED);
    fetchCreditData({});

    router.push({
      pathname: Routes.TRANSACTION_HISTORY,
      query: queryParams
    });
  }
  const isMobile = isMobileDevice();
  return (
    <>
      <Head>
        <title>Job Hai - Transaction History</title>
      </Head>
      <Layout
        isFooter={false}
        isLogin={true}
        isHeaderFixed={true}
        pathname={pathname}
      >
        {fetchedState === "LOADING" || creditFetchedState === "LOADING" ? (
          <Loader />
        ) : (
          <>
            <div className={`${classes.topContainer} border-b border-gray-200`}>
              <div className={classes.left}>
                <JhText variant="emphasis4" color="foreground">
                  Showing details for {data?.recruiterName}
                </JhText>
              </div>
              {!isMobile ? (
                <div className={classes.right}>
                  <CallCenter customClass={classes.callIcon} />
                </div>
              ) : null}
            </div>
            <div className={classes.root}>
              <TransactionHistory
                isReservedTab={isReservedTab}
                goToBack={goToBack}
                onRefresh={onRefresh}
              />
            </div>
            {isMobileDevice() ? (
              <div className="border-t border-gray-200 sticky bottom-0 bg-white p-4 flex space-x-3">
                <ActionButton
                  iconSrc="/hire/headset-mic-new.svg"
                  iconAlt="mic"
                  label={
                    <a
                      href={`tel:${HELP_CONTACT}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Call
                    </a>
                  }
                  onClick={null}
                />
                <ActionButton
                  iconSrc="/hire/credit-refresh-new.svg"
                  iconAlt="refresh"
                  label="Refresh"
                  onClick={onRefresh}
                />
              </div>
            ) : null}
          </>
        )}
      </Layout>
    </>
  );
}
